import MainNav from "../nav/MainNav.jsx";
import IntroTutorial from "../IntroTutorial.jsx";
import AlertBanner from "../AlertBanner.jsx";

export default function ClassicLayout({ navProps, children }) {
  return (
    <div className="app-shell">
      <MainNav {...navProps} />
      <AlertBanner top={60} />
      <main>{children}</main>
      <IntroTutorial />
    </div>
  );
}
